import LeadMagnetHeroTeaser from '@/components/leadmagnet/LeadMagnetHeroTeaser';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const directions = [
    'Компетенции', 'Потенциал', 'Зоны развития',
    'Кадровый резерв', 'План развития', 'Обучение',
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20concept%20of%20employee%20assessment%20and%20competency%20evaluation%20with%20stylized%20human%20figures%20standing%20on%20ascending%20geometric%20progress%20steps%20and%20subtle%20rating%20gauges%20representing%20potential%2C%20strong%20sides%20and%20development%20zones%2C%20elegant%20teal%20emerald%20green%20and%20warm%20beige%20ivory%20color%20palette%20on%20soft%20white%20background%2C%20clean%20minimal%20flat%20geometric%20design%20with%20soft%20gradients%20and%20subtle%20depth%2C%20harmonious%20professional%20business%20atmosphere%2C%20editorial%20quality&width=1600&height=900&seq=assessment-development-hero-2026&orientation=landscape"
          alt="Оценка и развитие сотрудников — оценка компетенций и развитие персонала"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-32 md:pt-24 pb-12 md:pb-16">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-3">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
              Оценка и развитие сотрудников: как определить потенциал и точки роста команды
            </h1>
            <p className="text-sm md:text-lg text-white/85 mb-4 leading-relaxed max-w-xl">
              Помогаем компаниям определить сильные стороны сотрудников, выявить зоны развития, оценить управленческий и профессиональный потенциал и связать результаты оценки с обучением и развитием.
            </p>
            <p className="text-sm text-white/60 mb-6">
              Для компаний, которые хотят развивать сотрудников системно, формировать кадровый резерв и принимать решения о развитии на основе объективных данных.
            </p>

            <div className="flex flex-wrap gap-2 mb-8">
              {directions.map((dir) => (
                <span key={dir} className="bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 px-3 py-1.5 rounded-full text-xs font-medium">
                  {dir}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Провести оценку сотрудников
                <i className="ri-arrow-right-line"></i>
              </button>
              <LeadMagnetHeroTeaser />
            </div>
            <p className="text-white/50 text-xs mt-3">
              Оценка занимает 2–3 недели и завершается отчётом с рекомендациями по развитию каждого сотрудника.
            </p>
          </div>

          <div className="lg:col-span-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 md:p-6 text-white">
            <div className="flex items-center gap-4 mb-5">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden flex-shrink-0 border-2 border-white/30">
                <img
                  src="https://storage.helloreaddy.io/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/a74b8d07-08c1-4959-a4cf-b4c9559a793b_compressed_Image156.webp"
                  alt="Алексей Сивко"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold">Алексей Сивко</h3>
                <p className="text-white/70 text-xs md:text-sm">Бизнес-тренер, консультант, коуч</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {[
                { value: '18+', label: 'лет практики' },
                { value: '100+', label: 'корпоративных проектов' },
                { value: '450+', label: 'тренингов' },
                { value: '4500+', label: 'участников' },
              ].map((stat, i) => (
                <div key={i} className="bg-white/10 rounded-xl p-3 text-center">
                  <div className="text-xl md:text-2xl font-extrabold text-teal-400">{stat.value}</div>
                  <div className="text-white/60 text-xs mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <p className="text-white/60 text-xs mt-4 leading-relaxed">
              Работал с компаниями Беларуси, России, Казахстана и Израиля. Средняя оценка участников — 9,09/10.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}